import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class ExplainerAddonModelType extends Cloneable {
    static NONE = new ExplainerAddonModelType(0, "NONE");
    static COLLECTION = new ExplainerAddonModelType(1, "COLLECTION");
    static MESSAGE = new ExplainerAddonModelType(2, "MESSAGE");

    static _values = [
        ExplainerAddonModelType.NONE,
        ExplainerAddonModelType.COLLECTION,
        ExplainerAddonModelType.MESSAGE
    ];

    static getValues() {
        return ExplainerAddonModelType._values;
    }

    static getValue(id) {
        let value = ExplainerAddonModelType._values.find(v => v.id === id) || null;
        console.assert(value, "unknown value: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, ExplainerAddonModelType.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof ExplainerAddonModelType) {
            return ExplainerAddonModelType._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "None") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof ExplainerAddonModelType) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ExplainerAddonModelType());
        } else if (target instanceof ExplainerAddonModelType) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ExplainerAddonModelType, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});